import products from './products.js';
import Storage from './storage.js';
import Logger from './logger.js';

class LocalData {
    constructor() {

    }
    static get() {
        const sessionID = Storage.getCurrentSessionId();
        const activeImageID = Storage.get('activeImageID');
        const cropBox = Storage.get('cropBox');
        const orientation = Storage.get('orientation');
        const presentation = Storage.get('presentation');
        const paper = Storage.get('paper');
        const size = Storage.get('size');
        const product = Storage.get('selectProduct');
        const retouch = Storage.get('retouch');
        const retouchComment = Storage.get('retouch_comment');
        const gfxText = Storage.get('gfxText');
        const gfxInk = Storage.get('gfxInk');
        const thumbnailUrl = Storage.get('thumbnailUrl');
        const currentResolutionGrade = Storage.get('currentResolutionGrade');
        return {
            sessionID,
            activeImageID,
            cropBox,
            orientation,
            presentation,
            paper,
            size,
            product,
            retouch,
            retouchComment,
            gfxText,
            gfxInk,
            thumbnailUrl,
            currentResolutionGrade
        };
    }
    static async html() {
        this.data = LocalData.get();
        const product_permalink = await products.getProductPermalink(this.data.product) || '';
        return `
                <div class="mscp-product-data">
                    <p><strong>Active Image ID:</strong> ${this.data.activeImageID}</p>
                    <p style='word-break: break-all;'><strong>Crop Box:</strong> ${JSON.stringify(this.data.cropBox)}</p>
                    <p><strong>Orientation:</strong> ${this.data.orientation}</p>
                    <p><strong>Presentation:</strong> ${this.data.presentation}</p>
                    <p><strong>Paper:</strong> ${this.data.paper}</p>
                    <p><strong>Size:</strong> ${this.data.size}</p>
                    <p><strong>Product:</strong> ${this.data.product}</p>
                    <p><strong>Retouch:</strong> ${this.data.retouch}</p>
                    <p><strong>Retouch Comment:</strong> ${Storage.get('retouch_comment') || 'No comment'}</p>
                    <p><strong>Thumbnail URL:</strong> ${this.data.thumbnailUrl || 'No thumbnail'}</p>
                    <p><strong>Current Resolution Grade:</strong> ${this.data.currentResolutionGrade || 'Not set'}</p>
                    <a href="${product_permalink}">View Product</a>
                </div>
                `;
    }
}

export default LocalData;